import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermanentdelegationService } from '../../../services/PermanentDelegation/permanentdelegation.service';
import { Permanentdelegation } from '../../../interface/permanentdelegation/permanentdelegation';
import { AppComponent } from '../../../app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoleService } from '../../../shared/services/RoleService';
import { CommonModule } from '@angular/common';
import { SharedServices } from '../../../shared/services/shared.services';
 
 
@Component({
  selector: 'app-home',
  imports:[FormsModule,ReactiveFormsModule,CommonModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit{
  loggedUserEmail: string = '';
  isadmin: boolean = false;
 
  constructor(
    private router: Router,
    private permanentdelegationService: PermanentdelegationService,
    private appComponent: AppComponent ,
    private roleService: RoleService,
    private sharedService: SharedServices
  ) {}
 
  ngOnInit(): void {
    this.loggedUserEmail = this.appComponent.loggedUserEmail;
    this.roleService.hasRole(['A']).subscribe(isAdmin => {
      //this.isadmin = isAdmin;
      if(isAdmin){
        this.isadmin = true;
      }
        });
  }
  onClick(): void {
    const email = this.isadmin ? this.loggedUserEmail : this.appComponent.loggedUserEmail;
    this.permanentdelegationService.getLoggedUserInfo(email).subscribe(
      (response: Permanentdelegation[]) => {
        this.router.navigate(['PermanentDelegation/home/delegation'], { state: { data: response } });
      },
      (error: any) => {
        this.sharedService.openModal('Message', 'Permanent delegation is restricted to employees and expats only.');
      }
    );
  }
}
 
